import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import usePlayerManifest from "../hooks/usePlayerManifest";
import PlayerLayout from "../components/PlayerLayout";
import storage from '../nativeStorage';
import api from '../api';

export default function PlayerMyResults() {
  usePlayerManifest();
  const navigate = useNavigate();
  const token = storage.getItem("player_token");
  const myName = storage.getItem("player_name");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { navigate("/player/login"); return; }
    api.get("/player/my-results", { headers: { Authorization: "Bearer " + token } })
      .then(res => setResults(Array.isArray(res.data) ? res.data : []))
      .catch(err => setError(err.response?.data?.error || "Could not load results"))
      .finally(() => setLoading(false));
  }, []);

  const instructions = (
    <>
      <h2 style={{ fontSize: "14px", fontWeight: "700", color: "#14532d", marginBottom: "8px" }}>About this page</h2>
      <div style={{ fontSize: "12px", color: "#374151", lineHeight: "2.2" }}>
        Results appear here after your organiser archives each competition. A <strong>✅ Verified</strong> badge means a playing partner has confirmed your card.
      </div>
    </>
  );

  return (
    <PlayerLayout instructions={instructions}>
      <h1 style={{ fontSize: "20px", fontWeight: "800", color: "#14532d", marginBottom: "4px" }}>📊 My Results</h1>
      <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "20px" }}>{myName}</p>
      <div style={{ maxWidth: "700px" }}>
        {loading && <div style={{ textAlign: "center", padding: "40px", color: "#6b7280" }}>Loading...</div>}
        {error && <div style={{ background: "#fef2f2", color: "#b91c1c", padding: "12px 16px", borderRadius: "8px", fontSize: "13px" }}>{error}</div>}
        {!loading && results.length === 0 && !error && (
          <div style={{ background: "white", borderRadius: "10px", padding: "32px", textAlign: "center", color: "#9ca3af", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
            No archived results found yet. Results appear here after your organiser archives each competition.
          </div>
        )}
        {results.map((r, i) => (
          <div key={i} style={{ background: "white", borderRadius: "10px", padding: "16px", marginBottom: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", border: r.verified_by_name ? "1px solid #bbf7d0" : "1px solid #e5e7eb" }}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: "8px" }}>
              <div>
                <div style={{ fontWeight: "700", color: "#14532d", fontSize: "14px" }}>
                  {r.date ? new Date(r.date).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) : "Unknown date"}
                </div>
                <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                  {r.game_type}{r.course_name ? " — " + r.course_name : ""}{r.venue ? " — " + r.venue : ""}
                </div>
              </div>
              {r.verified_by_name ? (
                <span style={{ background: "#dcfce7", color: "#15803d", fontSize: "12px", fontWeight: "700", padding: "4px 10px", borderRadius: "20px", whiteSpace: "nowrap" }}>
                  ✅ Verified by {r.verified_by_name}
                </span>
              ) : (
                <span style={{ background: "#f9fafb", color: "#9ca3af", fontSize: "12px", padding: "4px 10px", borderRadius: "20px", border: "1px solid #e5e7eb" }}>
                  Unverified
                </span>
              )}
            </div>
            <div style={{ display: "flex", gap: "20px", marginTop: "12px", flexWrap: "wrap" }}>
              {r.rank && <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "22px", fontWeight: "900", color: r.rank === 1 ? "#c9a227" : "#14532d" }}>{r.rank === 1 ? "🥇" : r.rank === 2 ? "🥈" : r.rank === 3 ? "🥉" : r.rank}</div>
                <div style={{ fontSize: "10px", color: "#9ca3af", marginTop: "2px" }}>Position</div>
              </div>}
              {r.points > 0 && <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "20px", fontWeight: "700", color: "#2563eb" }}>{r.points}</div>
                <div style={{ fontSize: "10px", color: "#9ca3af", marginTop: "2px" }}>Points</div>
              </div>}
              {r.gross > 0 && <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "20px", fontWeight: "700", color: "#374151" }}>{r.gross}</div>
                <div style={{ fontSize: "10px", color: "#9ca3af", marginTop: "2px" }}>Gross</div>
              </div>}
              {r.net > 0 && <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "20px", fontWeight: "700", color: "#374151" }}>{r.net}</div>
                <div style={{ fontSize: "10px", color: "#9ca3af", marginTop: "2px" }}>Net</div>
              </div>}
            </div>
            {r.verified_at && (
              <div style={{ fontSize: "11px", color: "#9ca3af", marginTop: "8px" }}>
                Verified {new Date(r.verified_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
              </div>
            )}
          </div>
        ))}
      </div>
    </PlayerLayout>
  );
}
